import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { axisClasses } from '@mui/x-charts';

const chartSetting = {
//   yAxis: [
//     {
//       label: 'rainfall (mm)',
//     },
//   ],
  width: 300,
  height:100,
  marginBottom:0,
  sx: {
    [`.${axisClasses.left} .${axisClasses.label}`]: {
      transform: 'translate(-20px, 0)',
    },
  },
};


// Validated categorical palette (dataviz skill: CVD-safe, contrast-checked against a white surface).
const colors = ['#16a34a', '#d97706', '#1d4ed8'];

export default function ConsumptionChart({data, series, height=250, width=350}) {

  return (
    <BarChart
      dataset={data}
      xAxis={[{ scaleType: 'band', dataKey: 'category' }]}
      series={series}
      colors={colors}
      borderRadius={6}
      {...chartSetting}
      height={height}
      width={width}
    />
  );
}
